var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"rounded-lg",attrs:{"width":"40px","height":"40px","min-width":"40px","color":"#F39200","disabled":_vm.disabled},on:{"click":_vm.download}},[_c('v-img',{attrs:{"max-width":"24","src":require("@assets/landingPage/download.svg")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }